import { useEffect } from 'react';

import { useAnalytics } from 'src/hooks/analytics/useAnalytics.hook';
import { useWorkspaceContext } from 'src/providers/WorkspaceProvider/Workspace.context';
import { tMetaErrorNotice } from 'src/utils/metaErrorNotice.types';

/** INT-1500 U3 (R6): the event the plan names, with the code in its payload. */
export const META_ERROR_NOTICE_UNMAPPED_EVENT = 'wapi_error_notice_unmapped';

// Failed messages already reported in this page session. A bubble mounts
// again when the chat is reopened or scrolled back into view: that is the
// same failure, not a new one.
const reportedEvents = new Set<string>();

/**
 * INT-1500 U3 (R6): reports a Meta code the catalog does not explain, once
 * per failed message, so the next catalog pass knows which codes sellers
 * meet. Waits for the workspace: the analytics helper drops events sent
 * before it (see useAnalytics).
 */
export default function useUnmappedNoticeTelemetry(
  notice: tMetaErrorNotice,
  eventId: string,
): void {
  const { trackEvent } = useAnalytics();
  const { currentWorkspaceId } = useWorkspaceContext();
  const code = notice.isFallback ? notice.displayCode : undefined;

  useEffect(() => {
    if (!code || !currentWorkspaceId) return;
    const key = `${eventId}:${code}`;
    if (reportedEvents.has(key)) return;
    reportedEvents.add(key);
    trackEvent(META_ERROR_NOTICE_UNMAPPED_EVENT, { code });
  }, [code, eventId, currentWorkspaceId, trackEvent]);
}
